import 'tablesorter';

export default {
  init() {
    // JavaScript to be fired on the home page
    $(function() {
      $('table thead th:eq(1)').data('sorter', false);
      $('table thead th:eq(4)').data('sorter', false);
      $('#directory').tablesorter();
    });
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/postTypeArchiveBusiness.js